import { render, staticRenderFns } from "./syncTipsDialog.vue?vue&type=template&id=f30161fe&"
import script from "./syncTipsDialog.vue?vue&type=script&lang=js&"
export * from "./syncTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./syncTipsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports